import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/contexts/AuthContext';
import {
  isPublicSiteHost,
  staffAbsoluteUrl,
} from '../lib/constants/hostRouting';

function isStandaloneDisplay(): boolean {
  if (typeof window === 'undefined') return false;
  if (window.matchMedia?.('(display-mode: standalone)').matches) return true;
  if (window.matchMedia?.('(display-mode: fullscreen)').matches) return true;
  const nav = window.navigator as Navigator & { standalone?: boolean };
  return nav.standalone === true;
}

/**
 * Si la PWA está instalada y hay sesión de equipo, abre el dashboard
 * en lugar de quedarse en la web pública.
 */
export function PwaStaffDashboardRedirect() {
  const { profile, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading || location.pathname !== '/') return;
    if (!isStandaloneDisplay()) return;
    if (!profile || profile.role === 'user') return;
    if (isPublicSiteHost(window.location.hostname)) {
      window.location.replace(staffAbsoluteUrl('/dashboard'));
      return;
    }
    navigate('/dashboard', { replace: true });
  }, [loading, location.pathname, profile, navigate]);

  return null;
}
